import React from "react";
import { StyledGainSum } from "../../dashboard.style";

const GainSum = ({ sum }) => {
  // const displaySum =
  //   sum && parseInt(sum) > 10000
  //     ? `${parseInt(sum) / 1000}k`
  //     : parseInt(sum).toLocaleString("en", { useGrouping: true });
  return (
    <StyledGainSum>
      {/* <h3>${displaySum}</h3> */}
      <h3>${sum}</h3>
      <p>Potential&nbsp;Revenue</p>
    </StyledGainSum>
  );
};
export default GainSum;
